import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import AdminModal from '../../../components/AdminModal';
import useToast from '../../../customHooks/useToast';
import { UPDATE_AGENT_STATUS } from '../../../graphql/admin_mutations';

import CircleCheckIcon from '../../../svgs/CircleCheckIcon';
// import AdminModal from '../../../../../components/AdminModal';
// import useToast from '../../../../../customHooks/useToast';
import Styles from './ActivateAgent.module.scss';

interface IActivateRole{
  onClose:any;
  payload:any;
  refetch:any;
}
const ActivateRealtor = ({ onClose, payload, refetch }:IActivateRole) => {
  const Toast = useToast();

  const [isSuccessful, setIsSuccessful] = useState(false);
  const [activate, { loading: activateLoading }] = useMutation<
  { updateAgentStatus: any },
  any
>(UPDATE_AGENT_STATUS);

  const activateAndDeactivateRole = async () => {
    const data = { agentId: payload?.id, isActive: true };
    if (!activateLoading) {
      try {
        const res = await activate({
          variables: data,
        });

        if (res?.data?.updateAgentStatus && res?.data?.updateAgentStatus?.status === 200) {
          refetch?.();
          setIsSuccessful(true);
        } else {
          Toast.error(res?.data?.updateAgentStatus?.message || 'Operation failed');
        }
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };
  return (
    <div className={Styles.wrapper}>
      <AdminModal
        headText={isSuccessful ? 'Realtor Activated!' : 'Are you sure you want to activate this realtor?'}
        subText={isSuccessful ? `${payload?.name} has been activated successfully.` : 'By clicking on “Activate”, you are accepting to reactivate this realtor. If you are not sure, please cancel.'}
        actionBtnName="activate"
        handleModalAction={activateAndDeactivateRole}
        topIcon={<div className={Styles.wrapper__icon}><CircleCheckIcon /></div>}
        isShow
        isActionBtnDisabled={activateLoading}
        isSuccess={isSuccessful}
        isTopIcon
        onClickAway={onClose}
        onClose={onClose}
        isLoading={activateLoading}
        hideLogo
        cancelBtnClass={Styles.wrapper__cancelBtn}
        actionBtnClass={isSuccessful ? Styles.wrapper__okayBtn : Styles.wrapper__deactivateBtn}
      />
    </div>
  );
};

export default ActivateRealtor;
